import React, { FC } from 'react';
import { Tag } from 'components/atoms/tag';
import { Color } from 'components/colors';

export type PriorityProps = {
  color: Color;
  label: string;
};

interface Props {
  priority: PriorityProps;
  className?: string;
}

export const Priority: FC<Props> = ({
  priority: { color, label },
  className,
}) => {
  return (
    <Tag color={color} className={className}>
      {label}
    </Tag>
  );
};
